import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'es',
        debug: false,
        detection: {
            order: ['querystring', 'navigator', 'cookie'],
            caches: ['cookie'],
            lookupQuerystring: 'lng',
        },
        backend: {
            loadPath: `./assets/locales/{{lng}}.json`,
        },
        supportedLngs: ['es', 'en'],
        interpolation: {
            escapeValue: false,
        },
        saveMissing: true,
        react: {
            useSuspense: false,
        },
    });

export default i18n;
